import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../../../../shared/src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { CoreService } from "../../../../../../../shared/src/lib/services/core.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NextEventsService {
  http = inject(HttpClient);
  coreService = inject(CoreService);
  titleRace$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  comingUpRaces$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  nextGreyhoundRace$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private locale = this.coreService.getLocale();
  greyhoundRacingId = 4339;
  horseRacingId = 7;

  constructor() {}

  triggerFetch() {
    this.fetchNextHorseRaces();
    this.fetchNextGreyhoundRaces();
  }

  get now() {
    return new Date();
  }

  fetchNextHorseRaces() {
    this.http
      .get(`${environment.mURL}${environment.endpoints.nextEvents}/${this.horseRacingId}`, {
        params: { locale: this.locale },
      })
      .subscribe((response: any) => {
        if (response?.data && response?.data?.length > 0) {
          // console.log(response?.data);
          // Sort events by the closest to the current time
          const [first, ...others] = this.sortRaces(response.data);
          this.titleRace$.next(first);
          this.comingUpRaces$.next(others);
        }
      });
  }

  fetchNextGreyhoundRaces() {
    this.http
      .get(`${environment.mURL}${environment.endpoints.nextEvents}/${this.greyhoundRacingId}`, {
        params: { locale: this.locale },
      })
      .subscribe((response: any) => {
        if (response?.data && response?.data?.length > 0) {
          const [first] = this.sortRaces(response.data);
          this.nextGreyhoundRace$.next(first);
        }
      });
  }

  sortRaces(races: any[]) {
    return [...races]
      .sort((a: any, b: any) => {
        const dateA = new Date(a.startTime);
        const dateB = new Date(b.startTime);
        return Math.abs(dateA.getTime() - this.now.getTime()) - Math.abs(dateB.getTime() - this.now.getTime());
      })
      .slice(0, 4);
  }
}
